export default function readFileBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.addEventListener("load", () => resolve(fileReader.result.split(",")[1]));
    fileReader.addEventListener("error", reject);
  });
}
